import React from 'react';
import './styles.css';

interface CharacteristicInputProps {
    name: string;
    label: string;
    value: string | number | undefined;
    min: number;
    max: number;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CharacteristicInput: React.FC<CharacteristicInputProps> = ({ name, label, value, min, max, onChange }) => (
    <div className='characteristics-item'>
        <label htmlFor={name}>{label}</label>
        <input
            type="number"
            name={name}
            min={min}
            max={max}
            step="1"
            id={name}
            value={value ?? ''}
            onChange={onChange}
        />
    </div>
);

export default CharacteristicInput;